import React from "react";
import BaseProductsBrowser from "@menu/components/BaseProductsBrowserV2";
import dynamic from "next/dynamic";
import {logModuleLoadError} from "src/core/common/utils";
import ActionsSortFilter from "../../../baseTheme/elements/filters/ActionsSortFilter";
import AppliedFiltersSection from "src/themes/baseTheme/elements/filters/AppliedFiltersSection";
import ShowcaseDealsList from "@menu/components/ShowcaseDealsList";
import styled from "styled-components";
import {CarouselProductsList} from "@ui";

const SearchProductsList = dynamic(() =>
  import("@menu/components/SearchProductsList").catch(
    logModuleLoadError("SearchProductsList", {critical: true})
  )
);
const ShowCaseProductsList = dynamic(() =>
  import("@menu/components/ShowCaseProductsList").catch(
    logModuleLoadError("ShowCaseProductsList", {critical: true})
  )
);
const ProductsList = dynamic(() =>
  import("@menu/components/ProductsList").catch(
    logModuleLoadError("ProductsList", {critical: true})
  )
);

const ShowcaseRecommendedProductsList = dynamic(() =>
  import("@menu/components/ShowcaseRecommendedProductsList").catch(
    logModuleLoadError("ShowcaseRecommendedProductsList", {critical: true})
  )
);

export default function SenseCategorizedProductsBrowser({hideFilters, disableMaxWidth}) {
  return (
    <BaseProductsBrowser
      disableMaxWidth={disableMaxWidth}
      render={({category, subcategories, filters}) => {
        const hasFilters = filters.hasFilters();

        return (
          <>
            {hasFilters && <AppliedFiltersSection filters={filters} />}

            {!filters.search && filters.category && (
              <Container>
                <ProductsList
                  title={category ? category.getName() : ""}
                  description={category ? category.getDescription() : undefined}
                  category={category}
                  subcategories={subcategories}
                  filters={filters}
                />
              </Container>
            )}

            {!filters.search && !filters.category && !category && (
              <div>
                <Container>
                  {!hideFilters && <ActionsSortFilter filters={filters} />}
                </Container>
                <ShowcaseDealsList />
                <ShowcaseRecommendedProductsList
                  filters={filters}
                  ProductsListComponent={CarouselProductsList}
                />
                <ShowCaseProductsList filters={filters} />
              </div>
            )}

            {filters.search && <SearchProductsList filters={filters} />}
          </>
        );
      }}
    />
  );
}

const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto;
`;
